module.exports = __webpack_public_path__ + "img/94d4025.png";